import { Icon, Tooltip } from '@roo/roo'
import React, { CSSProperties } from 'react'


const QuestionTooltip: React.FC<{children: React.ReactElement | string, style: CSSProperties}> = ({ children, style = {} }) => (
  <Tooltip content={<span style={{ hyphens: 'auto', wordBreak: 'break-word' }}>{children}</span>}>
    <Icon name="question-o" style={{  color: '#5C5C5C', marginLeft: '2px', ...style }} />
  </Tooltip>
)

export default QuestionTooltip